import React from 'react';

const AppPricing = () => {
  return (
    <section className="py-32 bg-background" id="pricing" data-testid="pricing-section">
      <div className="max-w-container-max mx-auto px-margin-desktop">
        <div className="text-center mb-20">
          <h2 className="font-headline-lg text-headline-lg text-primary mb-4">Transparent Pricing</h2>
          <p className="font-body-md text-body-md text-on-surface-variant">No hidden costs. Just pure business power.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Tier 1: Free Trial */}
          <div className="bg-surface-container-lowest executive-border rounded-2xl p-card-padding flex flex-col h-full" data-testid="pricing-free">
            <div className="mb-8">
              <h3 className="font-headline-md text-headline-md text-primary mb-2">Free Trial</h3>
              <p className="font-body-sm text-body-sm text-on-surface-variant">Experience the power first.</p>
            </div>
            <div className="mb-10">
              <span className="text-display-lg font-display-lg text-primary">&#x20B9;0</span>
              <span className="text-on-surface-variant">/14 days</span>
              <p className="text-body-sm text-on-surface-variant mt-2">then &#x20B9;19/mo.</p>
            </div>
            <ul className="space-y-4 mb-12 flex-grow list-none p-0 m-0">
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Full Voice Control
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Stock Management
              </li>
              <li className="flex items-center gap-3 text-body-md text-on-surface-variant opacity-50">
                <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>cancel</span>
                AI Business Report
              </li>
            </ul>
            <button className="w-full executive-border py-4 rounded-xl font-bold hover:bg-surface-container transition-all" data-testid="pricing-free-cta">
              Start Now
            </button>
          </div>

          {/* Tier 2: Premium (Most Popular) */}
          <div className="bg-surface-container-lowest executive-border rounded-2xl p-card-padding flex flex-col h-full relative border-primary ring-1 ring-primary" data-testid="pricing-premium">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-background px-4 py-1 rounded-full font-label-caps text-label-caps">MOST POPULAR</div>
            <div className="mb-8">
              <h3 className="font-headline-md text-headline-md text-primary mb-2">Premium</h3>
              <p className="font-body-sm text-body-sm text-on-surface-variant">Total business control.</p>
            </div>
            <div className="mb-10">
              <span className="text-display-lg font-display-lg text-primary">&#x20B9;99</span>
              <span className="text-on-surface-variant">/mo</span>
            </div>
            <ul className="space-y-4 mb-12 flex-grow list-none p-0 m-0">
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Everything in Free Trial
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Customer Khata Reminders
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Advanced AI Analytics
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Priority 24/7 Support
              </li>
            </ul>
            <button className="w-full bg-primary text-on-primary py-4 rounded-xl font-bold hover:opacity-90 transition-all" data-testid="pricing-premium-cta">
              Choose Premium
            </button>
          </div>

          {/* Tier 3: AI Business Report */}
          <div className="bg-surface-container-lowest executive-border rounded-2xl p-card-padding flex flex-col h-full" data-testid="pricing-report">
            <div className="mb-8">
              <h3 className="font-headline-md text-headline-md text-primary mb-2">AI Business Report</h3>
              <p className="font-body-sm text-body-sm text-on-surface-variant">Strategic expert insights.</p>
            </div>
            <div className="mb-10">
              <span className="text-display-lg font-display-lg text-primary">&#x20B9;899</span>
              <span className="text-on-surface-variant"> one-time</span>
            </div>
            <ul className="space-y-4 mb-12 flex-grow list-none p-0 m-0">
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Detailed Yearly Growth Plan
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Tax Ready Document Pack
              </li>
              <li className="flex items-center gap-3 text-body-md">
                <span className="material-symbols-outlined text-tertiary-fixed" style={{ fontSize: '20px' }}>check_circle</span>
                Competitor Gap Analysis
              </li>
            </ul>
            <button className="w-full executive-border py-4 rounded-xl font-bold hover:bg-surface-container transition-all" data-testid="pricing-report-cta">
              Buy Report
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AppPricing;
